import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'material-ui';
import * as actions from '../inspection.actions';
import { getInspectionById } from '../inspection.selectors';
import { getInspectionTitle } from '../../inspectionType/inspectionType.selectors';

import { PageAppBar } from '../../core/components/';
import { InspectionFieldTemplate } from '../../common/components/form/templates';
import { SchemaView } from '../../common/components/form';
import { widgets } from '../../common/components/form/widgets/readonly';
import { fields } from '../../common/components/form/fields/readonly';
import { InspectionFormContext } from './';
import {
  getNextFilteredReportId,
  getPreviousFilteredReportId,
} from '../../reports/reports.selectors';
import { withStyles } from 'material-ui/styles/index';
import { ICONS } from '../../../icons/Icons';
import Icon from '../../../icons/Icon';
import Paper from 'material-ui/Paper';
import { uppercaseFirst } from '../../../utils/user-utils';
import { getCurrentUserRole, getCurrentUserCompany } from '../../user/user.selectors';
import { UserRoles } from '../../user/user.constants';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  content: {
    position: 'relative',
    maxWidth: 1040,
    margin: '0 auto',
  },
  appBar: {
    maxWidth: 1040,
  },
  buttonWrap: {
    display: 'flex',
    maxWidth: 1040,
    margin: '0 auto',
    '@media (max-width:520px)': {
      display: 'none',
    },
  },
  buttonWrapMobile: {
    display: 'none',
    '@media (max-width:520px)': {
      display: 'block',
      position: 'absolute',
      top: '-3rem',
      right: 0,
    },
  },
  button: {
    color: '#fff',
    display: 'inline-block',
  },
  buttonCopy: {
    flex: 1,
    textAlign: 'left',
  },
  buttonCopyDisabled: {
    position: 'absolute',
    right: 0,
    bottom: '0.5rem',
    color: '#aaa',
  },
  buttonDisabled: {
    color: '#fff',
    opacity: '0.5',
  },
  icon: {
    paddingBottom: '2px',
  },
});

class InspectionView extends Component {
  static propTypes = {
    backPath: PropTypes.string.isRequired,
    inspection: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    readInspection: PropTypes.func.isRequired,
    readInspectionTypes: PropTypes.func.isRequired,
    copyInspection: PropTypes.func.isRequired,
    subtitle: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      frontendData: props.inspection && props.inspection.formData,
    };
  }

  componentDidMount = () => {
    const {
      readInspection,
      readInspectionTypes,
      readInspections,
      readFormDatas,
      readInspectionSchemas,
      printable,
      id,
      company,
    } = this.props;
    readInspection(id);    
    readInspectionTypes(company);
    /* 
    The other inspections are needed for prev / next buttons. Loading them is
    currently very slow in production due to childish nesting in the database
    queries. On printable version the prev / next are not needed and therefore
    the population of the inspections collection can be skipped.
    */
    if (!printable) readInspections();
    readFormDatas();
    readInspectionSchemas(company);
  };

  componentWillUpdate = (nextProps, nextState) => {
    if (nextProps.inspection && nextProps.inspection.formData) {
      if (
        !this.state.frontendData ||
        nextProps.inspection.formData.identifier !==
          this.state.frontendData.identifier
      ) {
        this.setState({
          frontendData: nextProps.inspection.formData,
        });
      }
    }
  };

  onInit = event => {
    this.updateState(event);
  };

  updateState = event => {
    this.setState({
      frontendData: event.formData,
    });
  };

  duplicate = () => {
    const { copyInspection, id } = this.props;
    // console.log('duplicate report, id:', id);
    copyInspection(id);
  };

  gotoPrevious = () => {
    const { readInspection, previousReportId, history } = this.props;
    readInspection(previousReportId).then(() => {
      history.push(`/inspection/view/${previousReportId}/raportti`);
    });
  };

  gotoNext = () => {
    const { readInspection, nextReportId, history } = this.props;
    readInspection(nextReportId).then(() => {
      history.push(`/inspection/view/${nextReportId}/raportti`);
    });
  };
  isAvailable = () => {
    const { company } = this.props;
    let formId = this.props.inspection.formSchema.id;
    return( (company && company === 'wihuri') && (formId && formId.split('.')[0] === 'cat') )
  };

  render() {
    const {
      backPath,
      inspection: { formSchema = null, formContext = null, uiSchema = null },
      subtitle = '',
      nextReportId = null,
      previousReportId = null,
      classes,
      role,
    } = this.props;

    if (classes.button.indexOf('pdfHide') < 0) {
      classes.button = classes.button + ' pdfHide';
    }

    if (classes.buttonDisabled.indexOf('pdfHide') < 0) {
      classes.buttonDisabled = classes.buttonDisabled + ' pdfHide';
    }

    if (!formSchema || !this.state.frontendData) return null;
    const identifier = this.state.frontendData.identifier;
    const title = `ID ${identifier}`;
    const nextEnabled = nextReportId !== null;
    const prevEnabled = previousReportId !== null;
    const isGuest = role === UserRoles.GUEST;
    return (
      <InspectionFormContext
        errorsLoose={this.state.errorsLoose}
        errorsStrict={this.state.errorsStrict}
        formSchema={formSchema}
        expanded
        {...formContext}
        render={formContext => (
          <div className={classes.root}>
            <PageAppBar
              title={title}
              subtitle={uppercaseFirst(subtitle)}
              backPath={backPath}
            />
            <div className={classes.buttonWrap}>
              {!isGuest && (
                <Button
                  disabled={this.isAvailable()}
                  onClick={this.duplicate}
                  className={this.isAvailable() ? classes.button + ' ' + classes.buttonCopyDisabled : classes.button + ' ' + classes.buttonCopy}
                >
                  Luo Kopio
                </Button>
              )}
              <Button
                onClick={this.gotoPrevious}
                disabled={!prevEnabled}
                className={
                  prevEnabled ? classes.button : classes.buttonDisabled
                }
              >
                <Icon
                  fill="#fff"
                  className={classes.icon}
                  icon={ICONS.CHEVRON_LEFT}
                  width="25px"
                  height="11px"
                />Edellinen
              </Button>
              <Button
                onClick={this.gotoNext}
                disabled={!nextEnabled}
                className={
                  nextEnabled ? classes.button : classes.buttonDisabled
                }
              >
                Seuraava<Icon
                  fill="#fff"
                  className={classes.icon}
                  icon={ICONS.CHEVRON_RIGHT}
                  width="25px"
                  height="11px"
                />
              </Button>
            </div>

            <div className={classes.buttonWrapMobile}>
              <Button onClick={this.duplicate}>
                <Icon
                  fill="#fff"
                  icon={ICONS.COPY}
                  width="24px"
                  height="24px"
                />
              </Button>
            </div>

            <Paper className={classes.content}>
              <SchemaView
                noHtml5Validate
                noValidate
                autoComplete="off"
                FieldTemplate={InspectionFieldTemplate}
                showErrorList={false}
                schema={formSchema}
                uiSchema={uiSchema}
                fields={fields}
                widgets={widgets}
                formData={this.state.frontendData}
                formContext={formContext}
                onBlur={this.onBlur}
                onChange={this.onChange}
                onInit={this.onInit}
                onError={this.onError}
                onSubmit={this.onSubmit}
              >
                <span />
              </SchemaView>
            </Paper>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state, { match, backPath }) => {
  const { params: { id } } = match;
  const inspection = getInspectionById(state, id);
  const { formSchema = null } = inspection;
  const subtitle = formSchema && getInspectionTitle(state, formSchema.id);
  // const constructBackPathFromId = () => {
  //   const idSegments = formSchema.id.split('.');
  //   idSegments.pop();
  //   return idSegments.join('/');
  // };
  backPath = '/';
  const nextReportId = getNextFilteredReportId(state, id);
  const previousReportId = getPreviousFilteredReportId(state, id);
  const role = getCurrentUserRole(state);
  const company = getCurrentUserCompany(state);
  return {
    backPath,
    id,
    inspection,
    subtitle,
    nextReportId,
    previousReportId,
    role,
    company,
  };
};

export default connect(mapStateToProps, Object.assign({}, actions))(
  withStyles(styles)(InspectionView)
);



// WEBPACK FOOTER //
// ./src/modules/inspection/components/InspectionView.js